import { isNumber } from 'lodash'
import moment from 'moment'

export const categoryCompare = (program1, program2) => {
  if (!!program1.category && !!program2.category) {
    return program1.category.order - program2.category.order
  } else if (program1.category !== program2.category) {
    return 1
  }

  return 0
}

export const areRegistrationDatesAvailable = (course) => !!(course.registrationStartsAt && course.registrationEndsAt)

export const areRegistrationDatesUnavailable = (course) => !areRegistrationDatesAvailable(course)

export const hasRegistrationPeriodEnded = (course) =>
  areRegistrationDatesAvailable(course) && moment().tz(course.community.timezone).isAfter(moment(course.registrationEndsAt))

export const isSpotsAvailablePresent = (course) => isNumber(course.spotsAvailable) && course.spotsAvailable >= 0

export const canDisplaySpotsAvailableOnSignup = (course) =>
  (!hasRegistrationPeriodEnded(course) || areRegistrationDatesUnavailable(course)) && isSpotsAvailablePresent(course)

